import actionTypes from './action-types';

export default (state = { isLoggedIn: false }, action) => {
    switch (action.type) {
        case actionTypes.INITIALIZE:
            return {
                ...action.payload
            };
        case actionTypes.DEFAULT_ACTION:
            return {
                ...state,
                default: action.payload
            };
        case actionTypes.SET_IS_FETCHING_GEOLOCATION: {
            const { payload } = action;
            return {
                ...state,
                isFetchingGeolocation: payload.isFetchingGeolocation
            };
        }
        case actionTypes.SET_GEOLOCATION: {
            const { payload } = action;
            return {
                ...state,
                geolocation: payload
            };
        }
        case actionTypes.FAILED_LOADING_GEOLOCATION: {
            return {
                ...state,
                geolocation: null,
                isFetchingGeolocation: false
            };
        }
        case actionTypes.SET_MEMBER_HERO_IMAGE: {
            return {
                ...state,
                memberHeroImage: {
                    max: action.payload,
                    med: action.payload,
                    min: action.payload
                }
            };
        }
        default:
            return state;
    }
};
